import React from 'react';
import { History } from 'history';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';
import Button from '../shared/Button';
import Card, { CardBody } from '../shared/Card';
import { scrollBodyTo } from '../shared/Scroller';
import { Mobile, Tablet } from '../shared/styled/Media';
import Colours from '../shared/styled/Colours';
import HowToReturn from './HowToReturn';
import FormContainer from './FormContainer';

const GridWrap = styled.div`
  margin: auto;
  max-width: 1000px;
  width: 100%;
`;
const Header = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 0 1rem 0;

  h1,
  h2 {
    outline: none;
  }
`;
const FullScreenBookLayout = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: calc(100vh - 140px);
  padding: 0 1rem;
`;
const Container = styled.div`
  width: 31.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const Instructions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 37.5rem;
  ${CardBody} {
    padding: 2.5rem 2rem;
  }
`;
const Blade = styled.div<{ bg?: string }>`
  background-color: ${(props: { bg?: string }) =>
    props.bg ? props.bg : 'transparent'};
  // min-height: calc(100vh - 60px);
  margin: auto;
  padding: 3.75rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .start-button {
    width: 100%;
  }
`;
const BladeContainer = styled.div`
  max-width: 20rem;
  margin: auto;
`;
const Spacer = styled.div`
  margin-top: -90px;
  padding-bottom: 100px;
  visibility: hidden;
`;
type Props = {
  history: History;
};

export const LayoutFindOrder = ({ history }: Props) => (
  <GridWrap>
    <Mobile>
      <Blade bg={Colours.white}>
        <BladeContainer>
          <Header>
            <h1 className="text24--emphasis mb-4">Request a return</h1>
            <h2 className="text16 mb-0">3 simple steps to request a return</h2>
          </Header>
          <HowToReturn />
          <Button
            id="get-started"
            type="button"
            variant="secondary"
            className="start-button mb-4"
            onClick={() => {
              const loginForm = document.getElementById('login-form')!;
              scrollBodyTo(loginForm, 400, () => {
                const title = document.getElementById('login-form-title');
                if (title) title.focus();
              });
            }}
          >
            Lets get started
          </Button>
        </BladeContainer>
      </Blade>
      <Blade>
        <FormContainer history={history}>
          <Spacer id="login-form" />
          <Header>
            <h2 id="login-form-title" className="text24--emphasis">
              Find your order
            </h2>
          </Header>
        </FormContainer>
      </Blade>
    </Mobile>
    <Tablet>
      <FullScreenBookLayout>
        <Container>
          <FormContainer history={history}>
            <Header>
              <h1 className="text24--emphasis mb-4">Request a return</h1>
            </Header>
          </FormContainer>
        </Container>
        <Instructions>
          <Card isFlat>
            <CardBody>
              <Header>
                <h2 className="text16--emphasis">
                  3 simple steps to request a return
                </h2>
              </Header>
              <HowToReturn />
            </CardBody>
          </Card>
        </Instructions>
      </FullScreenBookLayout>
    </Tablet>
  </GridWrap>
);

export default withRouter(observer<any>(LayoutFindOrder));
